import { brandsSlider } from './blocks/brandsSlider';
import { catalogSidebar } from './blocks/catalogSidebar';
import { messageForm } from './blocks/messageForm';
import { features } from './blocks/features';
import { filter } from './blocks/filter';
import { howWork } from './blocks/howWork';
import { mainBanner } from './blocks/mainBanner';
import { numericRangeSelect } from './blocks/numericRangeSelect';
import { product } from './blocks/product';
import { productGallery } from './blocks/productGallery';
import { productShowcase } from './blocks/productShowcase';
import { promotionsSlider } from './blocks/promotionsSlider';
import { select } from './blocks/select';
import { topbar } from './blocks/topbar';
import { FocusingInput } from './lib/FocusingInput';
import { detailsGroup } from './lib/detailsGroup';
import { hideInterface } from './lib/hideInterface';
import { tooltip } from './blocks/tooltip';
import { tabs } from './blocks/tabs';
import { comparisonTable } from './blocks/comparisonTable';
import { initPlyr } from './blocks/plyr';
import { toc } from './blocks/toc';
import { contacts } from './blocks/contacts';
import { verticalTimeline } from './blocks/verticalTimeline';
import { mobileTimeline } from './blocks/mobileTimeline';
import { categoriesSlider } from './blocks/categoriesSlider';
import { numbersBanner } from './blocks/numbersBanner';
import { mainCategories } from './blocks/mainCategories';
import { howWorkCards } from './blocks/howWorkCards';
import { cases } from './blocks/cases';
import { authDialog } from './blocks/authDialog';
import { chat } from './blocks/chat';
import { goTop } from './blocks/goTop';

new FocusingInput('.form-control__input');
tooltip();
hideInterface();
topbar();
catalogSidebar();
mainBanner();
features();
productShowcase();
promotionsSlider();
brandsSlider();
howWork();
detailsGroup();
messageForm();
numericRangeSelect();
select();
filter();
product();
productGallery();
tabs();
comparisonTable();
initPlyr('.video-player__video, .video-player video, .prose video');
toc();
contacts();
verticalTimeline();
mobileTimeline();
categoriesSlider();
numbersBanner();
mainCategories();
howWorkCards();
cases();
authDialog();
chat();
goTop('.footer__gotop');

console.log('JS started');
